/** Voice-assistant types (OpenAI Realtime API, bundled in Jait). */
export const VOICE_ASSISTANT_INITIAL_STATE = {
    status: "disconnected",
    micActive: false,
    assistantSpeaking: false,
    userTranscript: "",
    assistantTranscript: "",
};
//# sourceMappingURL=voice-assistant.js.map